import React from 'react';
import { UserIntegration } from '../../../../entities/UserIntegration';
import { UserIntegrationService } from '../../../../services/UserIntegrationService';
import { AlertType } from '../../../../components/Alert';
import { AccountIntegrationRow } from '.././AccountIntegrationRow';
import GmailLogo from '../../../../images/logos/google_gmail.svg';

interface PropTypes {
  integration: UserIntegration;
  onIntegration: (ui: UserIntegration) => void;
  authorizeUrl: string;
  setAlertMessage: (message: string) => void;
  setAlertType: (type: AlertType) => void;
}

function GmailIcon(props: { logoPath: string }) {
  return (
    <div
      className='me-2 rounded-circle d-flex align-items-center justify-content-center bg-gray'
      style={{ width: '32px', height: '32px' }}
    >
      <img src={props.logoPath} style={{ width: '16px', height: '16px' }} />
    </div>
  );
}

// TODO: Delete this file as soon the outlook FF is deleted
export function DeprecatedGmailIntegrationRow(props: PropTypes) {
  async function handleEmailDisconnectClick() {
    try {
      await UserIntegrationService.disconnect(props.integration.id);
      props.onIntegration(null);
      props.setAlertMessage('Gmail integration was disconnected successfully!');
      props.setAlertType(AlertType.Success);
    } catch (e) {
      props.setAlertMessage('The Gmail integration could not be disconnected!');
      props.setAlertType(AlertType.Danger);
      console.error(e);
    }
  }

  return (
    <AccountIntegrationRow
      integration={props.integration}
      integrationIcon={<GmailIcon logoPath={GmailLogo} />}
      authorizeUrl={props.authorizeUrl}
      onDisconnect={handleEmailDisconnectClick}
      connectedMessage={'Gmail'}
      disconnectedMessage={'Gmail'}
      selectionMessage={'Connect your Gmail account.'}
      modalTitle={'Disconnect Gmail'}
      modalContent={'Are you sure you want to disconnect the Gmail account?'}
    />
  );
}
